// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__1JaiZ","OpenSection":"Section_OpenSection__2Molh","Icon":"Section_Icon__358tw","ExpandedMenu":"Section_ExpandedMenu__d9xuc"};